module.exports = __webpack_public_path__ + "img/2975ac24ecd04e92a4c209249d729582-1440.51f33b54.png";